import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { newsList } from "@/mocks/news";

export default function LatestNews() {
  const items = newsList.slice(0, 4);
  const lead = items[0];
  const rest = items.slice(1);

  return (
    <section className="bg-background-100 px-4 md:px-8 py-14 md:py-20">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <SectionHeading
            eyebrow="最新资讯"
            title="及时了解品牌动态"
            description="汇聚公司新闻、行业趋势与媒体报道，掌握第一时间的重要信息。"
          />
          <Link
            to="/news"
            className="inline-flex items-center gap-2 rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 whitespace-nowrap"
          >
            全部资讯
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <Link
            to={`/news/${lead.id}`}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
          >
            <div className="h-56 w-full overflow-hidden">
              <img
                src={lead.cover}
                alt={lead.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col gap-3 p-6">
              <div className="flex items-center gap-3 text-xs text-foreground-500">
                <span className="rounded-full bg-secondary-100 px-2.5 py-1 font-medium text-secondary-900">
                  {lead.type}
                </span>
                <span>{lead.date}</span>
              </div>
              <h3 className="font-heading text-lg font-semibold leading-snug text-foreground-950 group-hover:text-primary-600">
                {lead.title}
              </h3>
              <p className="text-sm leading-relaxed text-foreground-600">{lead.summary}</p>
            </div>
          </Link>

          <div className="flex flex-col gap-4">
            {rest.map((item) => (
              <Link
                key={item.id}
                to={`/news/${item.id}`}
                className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
              >
                <div className="hidden sm:block h-24 w-32 shrink-0 overflow-hidden rounded-md">
                  <img
                    src={item.cover}
                    alt={item.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col gap-2">
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="font-medium text-accent-600">{item.type}</span>
                    <span>{item.date}</span>
                  </div>
                  <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 group-hover:text-primary-600">
                    {item.title}
                  </h3>
                  <p className="hidden sm:block text-sm leading-relaxed text-foreground-500 line-clamp-2">
                    {item.summary}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}